import React from 'react';
import './PlanModal.css';

const PlanModal = ({ isOpen, onClose, onSelectPlan }) => {
  if (!isOpen) return null;

  const planes = [
    {
      id: 'basico',
      nombre: 'Plan Básico',
      precio: '4,99',
      descripcion: 'Ideal para mantener el contacto básico',
      caracteristicas: [
        'Chat con Doña Paquita',
        'Reporte básico diario',
        'Aviso de incidencias',
        'Realización de tareas (coming soon)'
      ],
      priceId: process.env.REACT_APP_STRIPE_PRICE_BASICO
    },
    {
      id: 'premium',
      nombre: 'Plan Premium',
      precio: '25',
      descripcion: 'La opción preferida para familias conectadas',
      caracteristicas: [
        'Llamada diaria',
        'Reporte pro',
        'Detección soledad no deseada',
        'Aviso incidencias',
        'Realización de tareas (coming soon)'
      ],
      priceId: process.env.REACT_APP_STRIPE_PRICE_PREMIUM
    },
    {
      id: 'buddy',
      nombre: 'Plan Buddy',
      precio: '99',
      precioOferta: '9,90',
      descripcion: 'Comunicación completa para grandes familias',
      popular: true,
      oferta: true,
      caracteristicas: [
        'Llamadas diarias',
        'Reporte premium',
        'Detección soledad no deseada',
        'Función mejora cognitiva',
        'Entrenamiento',
        'Realización de tareas (coming soon)'
      ],
      priceId: process.env.REACT_APP_STRIPE_PRICE_BUDDY
    }
  ];

  const handleSelectPlan = (plan) => {
    onSelectPlan(plan);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content plan-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>✕</button>

        <div className="modal-header">
          <h2>Selecciona un plan para tu abuelo</h2>
          <p>Elige el plan que mejor se adapte a las necesidades de tu familiar</p>
        </div>

        <div className="plans-grid">
          {planes.map((plan) => (
            <div key={plan.id} className={`plan-card ${plan.popular ? 'popular' : ''}`}>

              {plan.popular && <div className="popular-badge">Más popular</div>}

              {plan.oferta && (
                <div className="ribbon-navidad">
                  <span>🎁 OFERTA LANZAMIENTO</span>
                </div>
              )}

              <div className="plan-header">
                <h3>{plan.nombre}</h3>
                <p className="plan-description">{plan.descripcion}</p>
              </div>

              <div className="plan-price">
                {plan.oferta ? (
                  <>
                    <span className="price-old-plan">{plan.precio}€</span>
                    <span className="price-amount navidad">{plan.precioOferta}</span>
                    <span className="price-currency">€</span>
                    <span className="price-period">/mes</span>
                  </>
                ) : (
                  <>
                    <span className="price-amount">{plan.precio}</span>
                    <span className="price-currency">€</span>
                    <span className="price-period">/mes</span>
                  </>
                )}
              </div>

              {plan.oferta && (
                <p className="navidad-expiry">Oferta válida hasta el 31 de diciembre de 2026</p>
              )}

              <ul className="plan-features">
                {plan.caracteristicas.map((feature, index) => (
                  <li key={index}>
                    <span className="check-icon">✓</span>
                    {feature}
                  </li>
                ))}
              </ul>

              <button
                className={`btn-select-plan ${plan.popular ? 'primary' : 'secondary'}`}
                onClick={() => handleSelectPlan(plan)}
              >
                Elegir {plan.nombre}
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PlanModal;
